import SlotListDetails from "../../../../components/slot-list-details";

export default function VendorSuggestedSlotsModal({ data, onClose }) {
  const times = data?.availableTimeSlots;
  const selectedSlot = data?.selectedTimeSlot;

  return (
    <SlotListDetails
      times={times}
      selectedSlot={selectedSlot}
      isCalendly={data?.isCalendly}
      onClose={onClose}
    />
  );
}
